import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Nidheesha Rudraraju",
      review: "I had a fantastic experience with CS Consultancy. Their team is professional, knowledgeable, and genuinely cares about students' success. From guiding me through the application process to helping me choose the best university, they provided personalized support at every step. Their expertise in visa processing, scholarship opportunities, and career counseling made everything so much easier. They were always available to answer my questions and ensured a smooth transition to my dream university. I highly recommend this consultancy to anyone looking for reliable and efficient educational consultancy services!"
    },
    {
      name: "Bhukya Gowthami",
      review: "Hi, I'm Gowthami. My journey of selecting a university and securing admission for my master's was incredibly smooth, thanks to the outstanding support from CS Overseas Consultancy. Their dedicated team guided me through every step, ensuring a hassle-free experience. I highly recommend their services to anyone looking for a stress-free and efficient admission process."
    },
    {
      name: "Gangarapu siri",
      review: "One of the best consultancy that I can rely on. The whole process of getting my visa was very smooth. They guided me in each and every step. I am extremely pleased and happy with the way they have handled my entire process and helping me with all my queries. I recommend CS Overseas consultancy for future applicants for their visas."
    },
    {
      name: "Praharsha K",
      review: "CS Consultancy played a huge role in helping me achieve my goal of pursuing a master's in the U.S. Everyone on the team was always responsive and ready to assist whenever I needed help. They worked hard to ensure everything went smoothly, answering all my questions with patience and clarity. Their dedication gave me the confidence I needed throughout the process. I highly recommend them to anyone looking for reliable guidance!"
    },
    {
      name: "Vipparla Divya",
      review: "I had an excellent experience here which helped with my US college admission and visa process. The team was professional, supportive, and guided me through every step. They provided personalized advice, reviewed my documents, and prepared me for interviews. I highly recommend this consultancy for anyone looking to study abroad!"
    }
  ];

  return (
    <section className="bg-gray-100 py-16 px-8">
      <div className="max-w-7xl mx-auto text-center" style={{cursor:'default'}}>
        <h2 className="text-3xl font-bold text-gray-800 mb-4" style={{cursor:'default'}}>
          Students trust us for Uncompromised Service
        </h2>
        <p className="text-gray-600 mb-8" style={{cursor:'default'}}>
          Our track record of triumphs speaks for itself
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="ml-4">
                  <h3 className="font-semibold text-gray-800">{testimonial.name}</h3>
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">{testimonial.review}</p>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <a 
            href="https://maps.app.goo.gl/iEFJvTR8HBMepVSp9" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors duration-300"
            style={{backgroundColor:'#0F3A5E'}}
          >
            <span className="mr-2">📍</span>
            View All Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
